import { IErrorResponse } from "@api";
import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ID } from "@types";
import {
  IGetServiceProviderOptions,
  getRealisationRateMetrics,
} from "../services/serviceProviders";

interface IUseContextOptions extends IGetServiceProviderOptions {
  onError?: (error: IErrorResponse) => void;
}

export const useRealisationRates = (
  serviceProviderId: ID | undefined,
  options?: IUseContextOptions
) => {
  const { data, isLoading, isError, isSuccess, status, refetch, error } =
    useDataQuery(
      ["realisationRates", Number(serviceProviderId), options],
      async () => {
        const response = await getRealisationRateMetrics(
          serviceProviderId,
          options
        );
        return response.data;
      },
      {
        enabled: !!serviceProviderId,
      }
    );

  return { data, isLoading, isError, isSuccess, status, error, refetch };
};
